import type { ReactNode } from 'react';
import { Button } from 'components/ui/button';

import { usePostHog } from '@posthog/react';
import { FormattedMessage } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';

/** View brief's look, which the 360 view's Open contact shares. */
export const VIEW_BRIEF_CLASS_NAME = 'text-meta h-8 gap-1.5 rounded-lg px-3 font-semibold';

interface Props {
    /** The answer's id, which arrives once it has finished: until then the button waits, disabled. */
    aiChatMessageId: number | undefined;
}

/** View brief: the stored brief's page, in a new tab. */
export function MeetingPrepViewButton({ aiChatMessageId }: Props): ReactNode {
    const posthog = usePostHog();
    const label = <FormattedMessage id="ai-chat.meeting-prep.view-brief" defaultMessage="View brief" />;

    if (aiChatMessageId === undefined) {
        return (
            <Button variant="secondary" disabled className={VIEW_BRIEF_CLASS_NAME}>
                {label}
            </Button>
        );
    }
    return (
        <Button
            variant="secondary"
            className={VIEW_BRIEF_CLASS_NAME}
            nativeButton={false}
            role="link"
            render={<RouterLink to={`/ai-chat/meeting-prep/${aiChatMessageId}`} target="_blank" rel="noopener" />}
            onClick={() => posthog.capture('meeting_prep_view_opened')}
        >
            {label}
        </Button>
    );
}
